/* eslint-disable react/jsx-boolean-value */
import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';

import ModalWrapper from 'components/Modals/ModalWrapper';
import AutoCompleteInput from 'components/Common/Inputs/AutoCompleteInput';

class AssignToUserModalForm extends Component {
  static propTypes = {
    isShown: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    onConfirmAssign: PropTypes.func.isRequired,
    getItemsList: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      assignToUser: null,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(event) {
    const {
      onConfirmAssign,
      getItemsList,
    } = this.props;

    const {
      assignToUser
    } = this.state;

    event.preventDefault();

    const itemsList = getItemsList();
    if (!itemsList || itemsList.length === 0) {
      toastr.error('', 'Please close the window and try again');
      return;
    }

    onConfirmAssign(itemsList, assignToUser);
    this.setState({ assignToUser: null });
  }

  onAssignToUserSelectedItem = (lookupValue) => {
    this.setState({ assignToUser: lookupValue });
  };

  onAssignToUserChange = (e, value) => {
    const { assignToUser } = this.state;

    if (value === '') {
      this.setState({ assignToUser: null });
    }

    if (assignToUser && assignToUser.value !== value) {
      this.setState({ assignToUser: null });
    }
  };

  cancelAssign() {
    const { onCancel } = this.props;

    if (onCancel !== null) {
      this.setState({ assignToUser: null });
      onCancel();
    }
  }

  render() {
    const { isShown } = this.props;
    const { assignToUser } = this.state;

    return (
      <ModalWrapper
        headerClose={ false }
        isOpen={ isShown }
        title="Assign To User"
        btnConfirmTitle="Confirm"
        btnCancelTitle="Cancel"
        onCancel={ () => this.cancelAssign() }
        formId="assignToUserForm"
        modalSize="assign-to-user-modal"
        useDummySubmit={ true }
      >
        <div className="assign-to-user-modal">
          <form className="form-horizontal" id="assignToUserForm" name="assignToUserForm" onSubmit={ this.handleSubmit }>
            <div className="form-group">
              <div className="col-2">
                <label
                  htmlFor="legal-entity-id"
                  className="form-label m-2"
                >
                  User Account
                </label>
              </div>
              <div className="col-10">
                <AutoCompleteInput
                  id="assigned-user"
                  name="assignToUser"
                  category="user"
                  placeholder="Enter user name..."
                  value={ assignToUser || '' }
                  onSelectedItem={ lookupValue => this.onAssignToUserSelectedItem(lookupValue) }
                  onChange={ (e, value) => this.onAssignToUserChange(e, value) }
                />
              </div>
            </div>
            <button
              type="submit"
              id="dummy-add-form-btn"
              className="none"
            >Confirm
            </button>
          </form>
        </div>
      </ModalWrapper>
    );
  }
}

const mapDispatchToProps = dispatch => ({ dispatch });

const AssignToUserModalReduxForm = reduxForm({
  form: 'AssignToUserModalForm'
})(AssignToUserModalForm);

export const AssignToUserModal = connect(
  mapDispatchToProps,
)(AssignToUserModalReduxForm);

export default AssignToUserModal;
